import { render, staticRenderFns } from "./ChangeTarrif.vue?vue&type=template&id=10f5ea70&"
import script from "./ChangeTarrif.vue?vue&type=script&lang=js&"
export * from "./ChangeTarrif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports